/**
 * lib/api.js — thin fetch helper for HustleRoundup.
 * Reads REACT_APP_BACKEND_URL and threads the Bearer session token.
 */
const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;
const KEY = "hr_session_token";

export function saveToken(t)  { try { localStorage.setItem(KEY, t); } catch { /* ignore */ } }
export function readToken()   { try { return localStorage.getItem(KEY); } catch { return null; } }
export function clearToken()  { try { localStorage.removeItem(KEY); } catch { /* ignore */ } }

export async function apiFetch(path, opts = {}) {
  const headers = { "Content-Type": "application/json", ...(opts.headers || {}) };
  const tok = readToken();
  if (tok && !headers.Authorization) headers.Authorization = `Bearer ${tok}`;
  const res = await fetch(`${API}${path}`, {
    credentials: "include",
    ...opts,
    headers,
  });
  if (res.status === 204) return null;
  const text = await res.text();
  const data = text ? (() => { try { return JSON.parse(text); } catch { return text; } })() : null;
  if (!res.ok) {
    const err = new Error(data?.detail || data || `HTTP ${res.status}`);
    err.status = res.status;
    err.data   = data;
    throw err;
  }
  return data;
}

export async function fetchMe() {
  try { return await apiFetch("/auth/me"); } catch { return null; }
}
